/*
 * W1 Sports — the sport tabs on the routine section.
 *
 * Every sport's three cards are already in the markup; this only moves the
 * hidden attribute and the aria state. Nothing loads when a tab is pressed, so
 * there is no flash of a half-swapped card, the copy for all five sports is
 * there for a crawler to read, and with the script blocked the first sport
 * still shows rather than the section rendering empty.
 *
 * Runs once per section. The theme editor re-renders a single section without
 * reloading the page, so the same wiring has to survive being asked twice.
 */
(function () {
  'use strict';

  function wire(root) {
    if (root.dataset.w1spReady === 'true') return;
    root.dataset.w1spReady = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-w1sp-tab]'));
    if (tabs.length < 2) return;

    function select(tab) {
      tabs.forEach(function (candidate) {
        var on = candidate === tab;
        candidate.setAttribute('aria-selected', on ? 'true' : 'false');
        candidate.tabIndex = on ? 0 : -1;

        // getElementById rather than a selector, because a section id in the
        // theme editor looks like `template--17...__hero` and would have to be
        // escaped before it could go in a query.
        var panel = document.getElementById(candidate.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    }

    root.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-w1sp-tab]');
      if (tab && tabs.indexOf(tab) !== -1) select(tab);
    });

    root.addEventListener('keydown', function (event) {
      var index = tabs.indexOf(document.activeElement);
      if (index === -1) return;

      var next = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        next = tabs[(index + 1) % tabs.length];
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        next = tabs[(index - 1 + tabs.length) % tabs.length];
      } else if (event.key === 'Home') {
        next = tabs[0];
      } else if (event.key === 'End') {
        next = tabs[tabs.length - 1];
      }
      if (!next) return;

      event.preventDefault();
      next.focus();
      select(next);
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-w1sp-routine]').forEach(wire);
  }

  boot();
  document.addEventListener('DOMContentLoaded', function () {
    boot();
  });
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
